<template>
  <v-app id="app">
    <router-view></router-view>
    <AppSnackbar />
  </v-app>
</template>

<script>
import AppSnackbar from "@/components/AppSnackbar";
export default {
  name: "App",
  components: { AppSnackbar },
};
</script>
<style lang="sass">
@import '../node_modules/@fontsource/roboto/index.css'
</style>
